import React from 'react'
import cx from 'classnames'

import { Button } from 'components/shared/Button/Button'

import styles from './IconButton.module.scss'

type IconButtonProps = Pick<
  React.ComponentProps<typeof Button>,
  | 'ariaLabel'
  | 'className'
  | 'color'
  | 'icon'
  | 'message'
  | 'size'
  | 'title'
  | 'variant'
  | 'onClick'
  | 'isDisabled'
  | 'isLocked'
>

export const IconButton = ({
  ariaLabel,
  className,
  color,
  icon,
  message,
  size,
  title,
  variant,
  onClick,
  isDisabled,
  isLocked,
}: IconButtonProps) => (
  <Button
    className={cx(
      styles.button,
      {
        [styles.size]: Boolean(size),
      },
      size && styles[size],
      className,
    )}
    {...{
      ariaLabel,
      color,
      icon,
      message,
      size,
      title,
      variant,
      onClick,
      isDisabled,
      isLocked,
    }}
  />
)
